<template>
  <div class="singerdetail">
    <singer-info @modalMessage="modalMessage=$event"></singer-info>
    <singer-song></singer-song>
    <partner></partner>

    <modal :modal-title="modalTitle" :modal-message="modalMessage"></modal>
  </div>
</template>

<script>
  import Info from './Info'
  import SingerSong from './Song'
  import Partner from '../../home/web/Partner'

  export default {
    name: "SingerDetail",
    components: {
      "singer-info": Info,
      "singer-song": SingerSong,
      "partner": Partner
    },
    data () {
      return {
        modalTitle: "Thông báo",
        modalMessage: "",
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/singerdetail/web/SingerDetail.vue